import { BaseDialog } from '../../../common/dialogs/BaseDialog';
import { ConfirmLeaveWithoutSaveDialog } from '../../../common/dialogs/ConfirmLeaveWithoutSave/ConfirmLeaveWithoutSaveDialog';
import useConfirm from '../../../common/dialogs/ConfirmLeaveWithoutSave/useConfirm';
import { InstructionsContent } from './InstructionsContent';
import { usePristineCard } from './usePristineCard';
interface InstructionsDialogProps {
  onClose: () => void;
}

export const InstructionsDialog = ({ onClose }: InstructionsDialogProps) => {
  const {
    setEditableCardPristineStates,
    isCreatingNew,
    setIsCreatingNew,
    setNewCardIsPristine,
    isPristine,
  } = usePristineCard();

  const { openConfirm } = useConfirm();

  const handleTryCloseDialog = async () => {
    if (!isPristine) {
      const isConfirmed = await openConfirm(<ConfirmLeaveWithoutSaveDialog />);
      if (!isConfirmed) return;
    }
    onClose();
  };

  return (
    <BaseDialog
      open={true}
      onClose={handleTryCloseDialog}
      PaperProps={{
        sx: {
          maxWidth: '900px',
          height: '100%',
          width: '100%',
        },
      }}
    >
      <InstructionsContent
        onClose={handleTryCloseDialog}
        setEditableCardPristineStates={setEditableCardPristineStates}
        setIsCreatingNew={setIsCreatingNew}
        isCreatingNew={isCreatingNew}
        setNewCardIsPristine={setNewCardIsPristine}
      />
    </BaseDialog>
  );
};
